import React from "react";
import {COMMON_DATA_LOADED } from "../../Redux/CommonReducer";

const SET_USER_LOGIN_EXPIRED = "locale/global/SET_USER_LOGIN_EXPIRED";

export const setUserLoginExpired = () => ({
    type: SET_USER_LOGIN_EXPIRED,
});

export const initialState = {
    commonModuleDataUpdatedAt: false,

    currentUser: {},
    activeModules: [],

    userLoginExpired: false,

    moduleConfigs: {
        "BOOKINGS": {
            enableSignIn: false
        }
    },
};

export const adminGlobalReducer = (state = initialState, action) => {

    // Intercept the admin common data loaded action within this reducer
    // so we can potentially store some data in the global admin store
    if (action.type && action.type == (`admin/${COMMON_DATA_LOADED}`)) {
        let newState = {
            ...state,
            ...action.payload.global,
            commonModuleDataUpdatedAt: new Date().toISOString()
        }

        return newState;
    }

    switch (action.type) {
        case SET_USER_LOGIN_EXPIRED: {
            return {
                ...state,
                userLoginExpired: true
            }
        }

        default:
            return state;
    }
};
